import Component from '../core/Component'
import { CMS } from '../core/config'
import {createTimeline} from 'animejs'

export default class WordAnimations extends Component {
    constructor(element, options) {
        super(element, options)
    }

    prepare() {
        if (CMS) {
            return
        }

        this.observer = new IntersectionObserver(this.handleIntersection)
        this.observer.observe(this.element)
    }
    
    destroy() {
        this.observer?.disconnect()
	}

    handleIntersection = (entries) => {
		if (!entries[0].isIntersecting) {
			return
		}
        this.observer.disconnect()
		this.observer = null
        this.run()
	}

    async run() {
        this.prepareWordGroupsInElement(this.element)
        const rowsByIndex = this.getRowsFromElement(this.element)
        const rows = Object.values(rowsByIndex.rowsByIndexInGroup)
        rows.forEach(row => {
            row.forEach(span => span.style.transform = `translateY(140%)`)
        })
        this.element.classList.add('is-ready')
        const animation = this.getTextAnimationIn(rows)
        await animation.play()
    }

    prepareWordGroupsInElement(element) {
        [...element.childNodes].forEach(childNode => {
            if (childNode.nodeType === 3) {
                const words = childNode.nodeValue.split(' ')
                words.forEach((word, index) => {
                    word = word.replace('\r','').replace('\n','')
                    if (word) {
                        const span = document.createElement('span')
                        span.innerHTML = `<span>${word}</span>`
                        span.className = 'Word'
                        element.insertBefore(span, childNode)
                    }

                    const isLast = index === words.length - 1
                    if (!isLast) {
                        const space = document.createTextNode(' ')
                        element.insertBefore(space, childNode)
                    }
                })
                element.removeChild(childNode)
            } else if (childNode.nodeType === 1) {
                if (childNode.tagName === 'IMG') {
                    const span = document.createElement('span')
                    span.innerHTML = `<span></span>`
                    span.className = 'Word Word--image'
                    childNode.parentNode.insertBefore(span,childNode)
                    span.querySelector('span').appendChild(childNode)
                } else {
                    this.prepareWordGroupsInElement(childNode)
                }
            } else {
                // nic
            }
        })
    }

    getRowsFromElement(element) {
        const wordEls = [...element.querySelectorAll('.Word')]
        let groupIndex = 0
        const groups = wordEls.reduce((acc,wordEl) => {
            if (!acc[groupIndex] || acc[groupIndex].parentNode !== wordEl.parentNode) {
                groupIndex += 1
                acc[groupIndex] = {
                    parentNode: wordEl.parentNode,
                    rows: {}
                }
            }
            const offset = wordEl.offsetTop
            if (!acc[groupIndex].rows[offset]) {
                acc[groupIndex].rows[offset] = []
            }


            // acc[groupIndex].rows[offset].push(wordEl)
            acc[groupIndex].rows[offset].push(wordEl.querySelector('span'))
            return acc
        }, {})

        const rowsByIndexInGroup = {}
        Object.values(groups).forEach(group => {
            Object.values(group.rows).forEach((row, index) => {
                if (!rowsByIndexInGroup[index]) {
                    rowsByIndexInGroup[index] = []
                }

                rowsByIndexInGroup[index].push(...row)
            })
        })

        return {
            groups,
            rowsByIndexInGroup
        }
    }

    getTextAnimationIn(rows = []) {
        const tl = createTimeline({
            autoplay: false
        })

        rows.forEach((row, index) => {
            tl.add(row, {
                translateY: ['120%','0%'],
                duration: 400,
                easing: 'easeOutExpo',
                delay: 10
            }, index === 0 ? '' : '-=300')
        })

        return tl
    }
}